import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PromocodeEffects } from './store/effects/promocode.effects';
import { promocodeReducer } from './store/reducers/promocode.reducer';

@NgModule({
  imports: [
    EffectsModule.forFeature([PromocodeEffects]),
    StoreModule.forFeature('promocode', promocodeReducer),
  ],
})
export class PromocodeModule {}
